var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState } from "react";
import { errorService } from "../../services/errorService";
import { useHistory } from "react-router-dom";
import useDebouncedState from "../util/useDebouncedState";
import { handleError } from "../../util";
export default ({ needToFetch = true, filters, tableSettings, setFilters, getList, getMeta, normalizeResponse, 
//@ts-ignore
normalizeFilters = (filters) => filters, }, fetchDependencies) => {
    var _a;
    const [pageCount, setPageCount] = useState(0);
    const [isFetching, setIsFetching] = useState(true);
    const [data, setData] = useState([]);
    const [query, setQuery] = useDebouncedState((_a = filters === null || filters === void 0 ? void 0 : filters.query) !== null && _a !== void 0 ? _a : "", (newValue) => {
        //@ts-ignore
        setFilters && setFilters({ query: newValue });
    }, 1000);
    const fetchData = (request) => __awaiter(void 0, void 0, void 0, function* () {
        setIsFetching(true);
        try {
            const requestWithSettings = Object.assign({ sortName: tableSettings === null || tableSettings === void 0 ? void 0 : tableSettings.sortName, sortDirection: tableSettings === null || tableSettings === void 0 ? void 0 : tableSettings.sortDirection, limit: tableSettings === null || tableSettings === void 0 ? void 0 : tableSettings.pageSize, offset: tableSettings
                    ? tableSettings.pageIndex * tableSettings.pageSize
                    : 0 }, request);
            const response = (yield getList(requestWithSettings)).data.result;
            let meta;
            if (getMeta)
                try {
                    meta = yield getMeta(requestWithSettings);
                }
                catch (error) {
                    handleError({
                        error,
                        defaultError: "Произошла ошибка с получением дополнительных данных",
                        setIsFetching,
                    });
                }
            const normalized = normalizeResponse
                ? normalizeResponse(response, {
                    setData,
                    meta,
                })
                : response.items;
            setPageCount(response.count);
            setData(normalized);
        }
        catch (error) {
            if (!String(error.config.baseURL).includes("https://mc.yandex.ru") ||
                !String(error.config.baseURL).includes("https://mc.yandex.ru/") ||
                !String(error.config.baseURL).includes("https://mc.yandex.ru/watch") ||
                !String(error.config.baseURL).includes(" https://mc.yandex.ru/watch/")) {
                setIsFetching(true);
                setData(error);
                errorService.show({
                    error,
                    source: "useListPage",
                });
            }
        }
        setIsFetching(false);
    });
    useEffect(() => {
        if (needToFetch) {
            const filtersNormalized = filters && normalizeFilters(filters);
            //@ts-ignore
            fetchData(Object.assign({}, filtersNormalized));
        }
    }, [
        // filters,
        // tableSettings,
        // tableSettings?.sortName,
        // tableSettings?.sortDirection,
        // tableSettings?.pageSize,
        // tableSettings?.pageIndex,
        needToFetch,
        JSON.stringify(fetchDependencies),
    ]);
    const history = useHistory();
    return {
        /**
         * Здесь хранятся дынные загруженные с помощью fetchData
         */
        data,
        setData,
        /**
         * Функция, которая запускается каждый раз при смене filters или tableSettings
         */
        fetchData,
        /**
         * Общее количество страниц
         */
        pageCount,
        isFetching,
        query,
        setQuery,
        history,
        setPageCount,
        setIsFetching,
    };
};
//# sourceMappingURL=useListPage.js.map